export const FBIcon = () => {
  return (
    <>
      <svg width="48" height="48" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="FB icon">
          <path
            id="path4680"
            d="M30.5747 32.0002C31.55 32.0002 32.3408 31.2094 32.3408 30.2341V1.76622C32.3408 0.790611 31.55 3.8147e-06 30.5747 3.8147e-06H2.10692C1.13131 3.8147e-06 0.34082 0.790611 0.34082 1.76622V30.2341C0.34082 31.2094 1.13131 32.0002 2.10692 32.0002H30.5747Z"
            fill="#3B5998"
          />
          <path
            id="path4684"
            d="M22.4203 32.0002V19.6082H26.5799L27.2027 14.7787H22.4203V11.6952C22.4203 10.297 22.8085 9.34415 24.8137 9.34415L27.3711 9.34296V5.0235C26.9287 4.96475 25.4107 4.83322 23.6446 4.83322C19.9573 4.83322 17.4331 7.08383 17.4331 11.2171V14.7787H13.2629V19.6082H17.4331V32.0002H22.4203Z"
            fill="white"
          />
        </g>
      </svg>
    </>
  );
};
